import { render, staticRenderFns } from "./SendMessageDetailTab.vue?vue&type=template&id=3da5e6f0&scoped=true&lang=pug"
import script from "./SendMessageDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendMessageDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDetailTab.vue?vue&type=style&index=0&id=3da5e6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5e6f0",
  null
  
)

export default component.exports